module.exports = __webpack_public_path__ + "img/up-arrow1.9ef19e0b.svg";